import React, { useEffect, useState } from 'react'
import Modal from './Modal'
import { userState } from '../../functions/stateList'
import ModalSubmitFormButton from '../buttons/ModalSubmitFormButton'
import moment from 'moment-jalaali'
import { userEditModalSubmit, userMainEditModalSubmit } from '../../functions/UserEditModalSubmit'
import UserModalBody from './UserModalBody'

function CarInfoUserModal({
  customer,
  setShowModal,
  car,
  setCar,
  customer_types,
  isMainCustomer = false,
  customers,
  setCustomerTypeListItem,
  setCustomers,
}) {
  const [inputs, setInputs] = useState({
    ...userState,
  })

  const [error, setError] = useState({
    ...userState,
    birth_date: '',
  })
  const [isSubmit, setIsSubmit] = useState(false)

  useEffect(() => {
    async function fetchData() {
      setInputs({
        full_name: customer?.full_name,
        gender: customer?.gender,
        mobile: customer?.mobile,
        customer_type: customer?.['customer_type_id'],
        birth_date: moment(customer?.birth_date).format('jYYYY/jMM/jDD'),
        description: null,
      })
      setError({
        ...userState,
      })
    }

    fetchData()
  }, [])

  const inputHandler = (e) => {
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    })
    setError({
      ...error,
      [e.target.name]: '',
    })
  }

  const formHandler = async (e) => {
    e.preventDefault()
    setIsSubmit(true)
    if (isMainCustomer) {
      await userMainEditModalSubmit(
        setIsSubmit,
        inputs,
        customer,
        setShowModal,
        error,
        setError,
        customers,
        customer_types,
        setCustomerTypeListItem,
        setCustomers,
        isSubmit
      )
    } else {
      await userEditModalSubmit(
        setIsSubmit,
        inputs,
        customer,
        car,
        setCar,
        setShowModal,
        error,
        setError
      )
    }
  }

  return (
    <Modal>
      <form onSubmit={formHandler}>
        {/*header*/}
        <div className="p-3 md:p-5">
          <h3 className="text-xl md:text-3xl font-semibold text-center dark:text-slate-200">
            اطلاعات فردی
          </h3>
        </div>

        {/*body*/}
        <UserModalBody
          setInputs={setInputs}
          inputs={inputs}
          error={error}
          isSubmit={isSubmit}
          inputHandler={inputHandler}
          customer_types={customer_types}
        />

        {/*footer*/}
        <ModalSubmitFormButton setShowModal={setShowModal} isSubmit={isSubmit} />
      </form>
    </Modal>
  )
}

export default React.memo(CarInfoUserModal)
